import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-5 col-lg-6 col-md-8 mx-auto" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<h1 class=\"display-3 mb-3 text-center\">Confirma tu identidad</h1><div class=\"text-center mb-3\"><div class=\"d-inline-flex align-items-center border_ text-center p-3_ pb-2_ fs-3\"><i class=\"bi bi-phone-vibrate text-secondary me-2\"></i> Ten a mano tu móvil </div><p class=\"fw-medium mb-0 mt-3\">Introduce el código que acabamos de enviarte por SMS a tu móvil. Ten en cuenta que puede tardar hasta un minuto en llegar: </p></div>", 2)
const _hoisted_8 = { class: "form-floating mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Código SMS", -1)
const _hoisted_10 = { class: "small text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary mt-4",
  type: "submit"
}, "Acceder", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"])),
              class: "mb-2",
              autocomplete: "off"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "floatingInput",
                  placeholder: "Código SMS",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.code]
                ]),
                _hoisted_9
              ]),
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = () => $setup.getCode())
                }, "Reenviar código")
              ]),
              _hoisted_11
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}